module.exports = __webpack_public_path__ + "static/media/home-layers.76d0053a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-layers.png
// module id = 545
// module chunks = 0